import { state } from '../map_state/state'
import { clamp, callMethodOnKeydown, isTyping } from '../helpers'
import { Renderer } from '../renderer'

class ZoomTool {
  constructor () {
    this.element = document.getElementById('mct-zoom-input')
    this.zoomInElement = document.getElementById('mct-zoom-in')
    this.zoomOutElement = document.getElementById('mct-zoom-out')
    this.step = 0.2
    this.bindEvents()
  }

  bindEvents () {
    this.zoomIn = this.zoomIn.bind(this)
    this.zoomOut = this.zoomOut.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.setZoomFromInput = this.setZoomFromInput.bind(this)
    this.zoomInElement.addEventListener('click', this.zoomIn)
    this.zoomOutElement.addEventListener('click', this.zoomOut)
    this.element.addEventListener('change', this.setZoomFromInput)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.zoomInElement.removeEventListener('click', this.zoomIn)
    this.zoomOutElement.removeEventListener('click', this.zoomOut)
    this.element.removeEventListener('change', this.setZoomFromInput)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === '=' || e.key === '+') callMethodOnKeydown(e.target, this.zoomIn)
    else if (e.key === '-' || e.key === '_') callMethodOnKeydown(e.target, this.zoomOut)
  }

  zoomIn () {
    this.setZoom(state.zoomValue + this.step)
  }

  zoomOut () {
    this.setZoom(state.zoomValue - this.step)
  }

  setZoom (newZoom) {
    const z = clamp(newZoom, 0.2, 4)
    state.zoomValue = z
    this.element.value = `${Math.round(z * 100)}%`
    Renderer.render()
  }

  setZoomFromInput () {
    let raw = (this.element.value || '').trim()
    if (!raw) return

    if (raw.endsWith('%')) raw = raw.slice(0, -1)

    const num = Number(raw)
    if (!Number.isFinite(num)) return

    this.setZoom(num / 100.0)
  }
}

export let zoomTool = null

export function initZoomTool () {
  zoomTool = new ZoomTool()
  return zoomTool
}
